<template>
  <div v-if="loaded" :class="'application-container animated fadeIn ' + pathToClass">
    <header class="navbar">
        <section class="navbar-section" v-if="currentUser.AccountID">
          <router-link :to="{ name: 'monitors.home'}" class="btn btn-link"><i class="fa fa-home"></i> Home</router-link>
          <router-link :to="{ name: 'account.index'}" class="btn btn-link"><i class="fa fa-rocket"></i> Notificators</router-link>
          <router-link :to="{ name: 'account.index'}" class="btn btn-link"><i class="fa fa-image"></i> Snapshots</router-link>
        </section>
        <section class="navbar-center" v-if="currentUser.AccountID">
            <router-link :to="{ name: 'monitors.home'}" class="logo"> <img src="/static/images/logo-white.png"> </router-link>
        </section>
        <section class="navbar-center" v-else>
          &nbsp;
        </section>
        <section class="navbar-section hide hidden" v-if="currentUser.AccountID">
          <router-link :to="{ name: 'monitors.home'}" class="btn btn-link"><i class="fa fa-list"></i> Monitors</router-link>
          <router-link :to="{ name: 'account.index'}" class="btn btn-link"><i class="fa fa-user"></i> Account</router-link>

          <router-link :to="{ name: 'account.index'}" class="credits"><i class="fa fa-leaf"></i> unlimited credits!</router-link>
        </section>
    </header>

    <div class="main">
      <router-view />
    </div>

    <footer>
      hey tehre
    </footer>
  </div>
  <div v-else class="big-loading-blanket">
      <div class="center-container animated fadeIn">
          <div v-if="errorLoading">
            <p class="">🙈 There was an error trying to load the application. Please try again in a few or contact us at <strong>hi@pagespy.io</strong></p>
          </div>
          <div v-else>
            <img class="" src="https://s3.amazonaws.com/pagespy/loading.svg" />
            <h2>Loading your dashboard 🤖</h2>
            <p class="sub">Gathering all the spies on duty ...</p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  beforeCreate() {
    // request all monitors too be loaded
    // this.$store.dispatch('getAllMonitors')
  },
  created() {
    this.getMe()
  },
  data () {
    return {
      loaded: false,
      errorLoading: false
    }
  },
  methods: {
    getMe() {
      if(this.$route.path != '/login') {
        var self = this;
        this.$http.get(`/me`).then((response) => {
          self.loaded = true
        }).catch((response) => {
          console.log(response);
          self.errorLoading = true
        })
      } else {
        this.loaded = true;
      }
    }
  },
  computed: {
    pathToClass() {
      return this.$route.name.replace(".", "-")
    }
  }
}
</script>

<style lang="scss">
* {
  outline: none !important;
}
a:focus {
    box-shadow: none;
}
html {
  background-repeat: no-repeat;
  min-height: 100%;

  body {
    // background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    background: #f4f6f8;

    &:after {
      background: #30364a;
      position: fixed;
      z-index: -1;
      width: 100%;
      height: 210px;
      content: '';
      top: 0;
      left: 0;
    }

    .btn {
      box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
      transition: all .15s ease;

      &:hover {
        box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
      }
    }

    input, input[type='text'], input[type='number'], select {
      background: #fff;
      border-radius: 2px;
      color: #636567;
    }

    .big-loading-blanket {

      .center-container {
        background: #fff;
        position: relative;
        top: 120px;
        margin: 0 auto;
        width: 53%;
        z-index: 100;
        text-align: center;
        padding: 54px;
        border-radius: 4px;
        box-shadow: 0px 0px 19px rgba(0, 0, 0, 0.1);
        font-size: 30px;

        h2 {
          font-size: 44px;
          margin: 0;
          font-weight: bold;
        }

        p.sub {
          opacity: 0.7;
        }

        p {
          margin: 0;
        }
      }
    }

    .navbar {
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%), radial-gradient(at top center, rgba(255, 255, 255, 0.4) 0%, #00459c 120%) rgba(195, 115, 255, 0.639216);
      background-blend-mode: multiply,multiply;
      margin-top: 39px;
      border-radius: 7px 7px 0px 0px;
      padding: 0px 12px;

      .btn.btn-link {
        color: #ffffff;
        font-size: 13px;
        text-shadow: 0px 1px 1px #154f58;
        font-weight: 300;

        .fa {
          opacity: 0.6;
        }

        &.router-link-exact-active {
          border-top: 1px solid #fff;
          font-weight: bold;
        }

        &:hover {
          background: rgba(97, 167, 248, 0.2196078431372549);
          color: #fff;
        }
      }

      .logo {
        img {
          width: 100px;
          position: relative;
          top: 2px;
        }
      }

      .credits {
        color: #fff;
        text-decoration: none;
        font-size: 11px;
        background: #30364a;
        padding: 2px 6px;
        border-radius: 100px;
        border: 1px solid #000;
        box-shadow: 0px 1px 0px #4e96fa, 2px 3px 5px #202533 inset;
        font-family: monospace;
      }
    }
  }
}

body .toasted-container.changenotify-toasted.top-right {
  top: 1%;
  right: 1%;
  font-family: "Helvetica Nueue", "Helvetica", sans-serif;

  .toasted {
    box-shadow: 0px 0px 10px #000;
  }

  .toasted.primary {
    background: linear-gradient(to bottom, #ffffff 0%,#f7f7f7 100%);
    color: #626262;
    border: 1px solid #cad0d4;
    box-shadow: 1px 1px 12px rgba(10, 10, 10, 0.11), 0 1px 0 rgba(255, 255, 255, 0.37) inset;
    font-weight: normal;
    font-size: 15px;
    transition: all 0.2s;
    border-radius: 3px;

    &:hover {
      box-shadow: 0px 0px 11px rgba(59, 110, 140, 0.25);
    }

    .show {}
    &.success {
      background: linear-gradient(to bottom, #cdeb8e 0%,#a5c956 100%);
      border-color: #90C611;
      color: #fff;
      text-shadow: 0px 1px 1px #000;

      .action {
        color: #fff;
      }
    }

    .info {}
    &.error {
      background: linear-gradient(to bottom, #ea7e7e 1%, #d60c10 100%);
      border-color: #A0090C;
      color: #fff;
      text-shadow: 0px 1px 1px #000;

      .action {
        color: #fff;
      }
    }
  }
}


.application-container {
  width: 1366px;
  margin: auto auto;
  box-shadow: 0px 84px 21px rgba(48, 54, 73, 0.121), 0px 84px 5px rgba(48, 54, 73, 0.12);
  border-radius: 8px;

  // new monitor button based on the page the thing is
  &.monitors-home {
    .new-monitor-button {
      width: 100%;
      background: #32b643;
      display: inline-block;
      color: #fff;
      text-align: center;
      padding: 8px 0px;
      margin: 9px 0px;
      margin-top: 0;
      position: relative;
      box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
      white-space: nowrap;
      border-radius: 4px;
      font-weight: 300;
      letter-spacing: .025em;
      text-decoration: none;
      transition: all .15s ease;
      border: 1px solid #32b643;
    }
  }

  &.monitors-show, &.monitors-new {
    .new-monitor-button {
      width: 100%;
      border: 1px solid #32b643;
      color: #32b643;
      display: inline-block;
      text-align: center;
      padding: 8px 0px;
      margin: 9px 0px;
      margin-top: 0;
      position: relative;
      white-space: nowrap;
      border-radius: 4px;
      letter-spacing: .025em;
      text-decoration: none;
      transition: all .15s ease;
      font-weight: 300;
    }

  }


  header#top {
    background: transparent;
    box-shadow: none;
    margin-top: 40px;

    &>div {
      display: inline-grid;
      width: 100%;

      a.logo {
        grid-column-start: 1;
        grid-column-end: 3;
      }

      ul.navigation {
        grid-column-start: 5;
        grid-column-end: span col3-end;
        text-align: right;

        a {
          background: transparent;
          color: #90acce;
          text-shadow: 0px 1px 1px #ffffff;

          &:hover {
            background: #fff;
            color: #000;
          }
        }
      }
    }

  }

  .main {
    background: #fff;
    border-radius: 4px;
    min-height: 100vh;
    position: relative;

    .widget {
      width: 100%;
      .header {
        border-radius: 4px;
        color: #566d7b;
        -webkit-box-shadow: 0px 8px 15px rgba(120, 197, 243, 0.18), 0px -1px 0px rgba(255, 255, 255, 0.27) inset;
        box-shadow: 0px 8px 15px rgba(120, 197, 243, 0.18), 0px -1px 0px rgba(255, 255, 255, 0.27) inset;
        text-shadow: 0px 1px 0px #fff;
        margin-top: 9px;

        h3 {
          padding: 11px 14px;
          margin: 0;
          font-weight: 600;
          font-size: 16px;
        }
      }

      .content {
        padding: 10px;
      }

    }
  }
}

form {
  border: 1px solid #f5f5f5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05), 0 2px 3px rgba(0, 0, 0, 0);
}

ul {
  padding: 0;
  margin: 0;
}

.common-Button {
    white-space: nowrap;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 14px;
    box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
    background: #fff;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .025em;
    color: #6772e5;
    text-decoration: none;
    transition: all .15s ease;

    &:hover {
        color: #7795f8;
        transform: translateY(-1px);
        box-shadow: 0 7px 14px rgba(50,50,93,.1),0 3px 6px rgba(0,0,0,.08)
    }

  &:active {
      color: #555abf;
      background-color: #f6f9fc;
      transform: translateY(1px);
      box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08)
  }
}



.common-Button--default {
    color: #fff;
    background: #6772e5
}

.common-Button--default:hover {
    color: #fff;
    background-color: #7795f8
}

.common-Button--default:active {
    color: #e6ebf1;
    background-color: #555abf
}

.common-Button--dark {
    color: #fff;
    background: #32325d
}

.common-Button--dark:hover {
    color: #fff;
    background-color: #43458b
}

.common-Button--dark:active {
    color: #e6ebf1;
    background-color: #32325d
}

.common-Button--disabled {
    color: #fff;
    background: #aab7c4;
    pointer-events: none
}

.common-ButtonIcon {
    display: inline;
    margin: 0 5px 0 0;
    position: relative
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background:rgba(0, 0, 0, 0.8);
    color: white;
    border-radius: 4px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 2px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

.toast.toast-error {
    background: #f75151;
    border-color: #f75051;
    color: #ffffff;
    margin: 15px 0;
    text-shadow: 0px 1px 1px #ad2526;
}

.tab.tab-block {
  box-shadow: 0px 1px 3px #f3f5f7;
  transition: all 0.2s;

  li.tab-item {
    a {
      transition: all 0.2s;
      &:hover {
        background-image: linear-gradient(to bottom, #ffffff, #eef3f9);
        transition: all 0.2s;
      }
      &.active {
        .fa, .far, .fab, .fal {
          color: rgba(51, 181, 67, 1);
        }
      }
      .fa, .far, .fab, .fal {
        color: rgba(51, 181, 67, 0.7215686274509804);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue